<template>
    <a-select
            v-model="model"
            :defaultActiveFirstOption="false"
            :filterOption="false"
            placeholder="请选择规格"
            :notFoundContent="null"
            @change="handleChange"
            :style="style"
    >
        <a-select-option v-for="(option, index) in options" :key="index">{{option}}
        </a-select-option>
    </a-select>
</template>
<script>
    import {skuDetail, getGoodsDetail} from '@/api/goods';

    export default {
        name: 'GoodsSkuPicker',
        data() {
            return {
                options: [],
                sku: [],
                sku_list: [],
                sku_fields_list: [],
                style: ''
            }
        },
        computed: {
            model: {
                get: function () {
                    return this.formData[this.skuTitle];
                },
                set: function () {
                }
            }
        },
        props: {
            formData: {
                type: Object,
                required: true
            },
            goodsId: {
                type: Number,
                required: true
            },
            skuId: {
                type: String | Number,
                required: true
            },
            skuTitle: {
                type: String | Number,
                required: true
            },
            type: {
                type: String | Number,
                required: true
            },
            goodsPrice: {
                type: String | Number,
                required: true
            },

        },
        watch: {
            goodsId() {
                console.log('------goods_id------')
                this.getskuDetail()
            },
        },
        created() {
        },
        methods: {
            getskuDetail() {
                let that = this
                skuDetail({goods_id: that.goodsId}).then(res => {
                    that.sku = that.sku_list = res.data.sku
                    that.sku_fields_list = res.data.sku_fields_list

                    that.sku_list.map((skuList) => {
                        skuList.sku_list = []
                        skuList.sku.map((sku) => {
                            skuList.sku_list.push(sku.attr_id)
                        })
                    })

                    that.formData[this.skuTitle] = ''
                    that.options = []

                    // 判断商品有没有sku
                    if (!res.data.sku_fields_list.length) {
                        this.formData[this.skuId] = '';
                        that.getGoodsDetail()
                        that.getGoodsType()
                    } else if (res.data.sku_fields_list.length == 1) {
                        res.data.sku_fields_list[0].attrs.map((sku) => {
                            that.options.push(sku.title)
                        })
                    } else {
                        that.getAttrName()
                    }
                })
            },

            // format sku名称
            getAttrName() {
                let that = this;
                // 获取每个sku的名称 
                that.sku.map((list, index) => {
                    that.sku_list.map((sku, skuIndex) => {
                        if (list.sku_list.sort().toString() === sku.sku_list.sort().toString()) {
                            var attrName = ''
                            that.sku_fields_list.map((sku) => {
                                sku.attrs.map((attr, attrIndex) => {
                                    that.sku_list[skuIndex].sku_list.map((skuAttr) => {
                                        if (skuAttr == attr.id) {
                                            attrName += sku.title + ':' + attr.title + ','
                                        }
                                        that.options[index] = attrName.substr(0, attrName.length - 1)
                                    })
                                })
                            })
                        }
                    })
                })

                console.log('options', that.options)
            },

            handleChange(value, options) {
                let that = this

                console.log('---value---', value, options)

                that.formData[this.skuId] = that.sku[value].id
                this.formData[this.goodsPrice] = that.sku[value].price;

                let selected = that.options.filter((item, index) => {
                    return index == value
                })
                console.log('selected', selected);
                this.formData[this.skuTitle] = selected[0];
                that.getGoodsType()
                console.log(this.formData)
            },


            getGoodsDetail() {
                let that = this;
                getGoodsDetail({id: that.goodsId}).then(res => {
                    that.formData[this.goodsPrice] = res.data.price
                })
            },

            getGoodsType() {
                let that = this;
                getGoodsDetail({id: that.goodsId}).then(res => {
                    that.formData[this.type] = res.data.type
                })
            }

        },
    }
</script>
<style>

</style>